import "./DashboardLayout.css";

export default function DashboardLayout({ children, exportDisabled = false }) {
  return (
    <div className="dashboard-layout" data-export-disabled={exportDisabled}>
      {children}
    </div>
  );
}